import { render, staticRenderFns } from "./RoleOperation.vue?vue&type=template&id=32455b48&scoped=true&"
import script from "./RoleOperation.vue?vue&type=script&lang=js&"
export * from "./RoleOperation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32455b48",
  null
  
)

export default component.exports